import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-chitmember-transfer',
  templateUrl: './chitmember-transfer.component.html',
  styleUrls: ['./chitmember-transfer.component.css']
})
export class ChitmemberTransferComponent implements OnInit {
  c:any={};
  data: any;
  chitschemecodelist: any=[];
  chitdetails: any=[];
  detailsBasedOntokenNo: any;
  custIdslist: any=[];
  detailsBasedOnCustId: any;
  title="Chit Member Transfer";

  constructor(private service:UserService,private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler) { }

  ngOnInit() {
    this.GetChitSchemeCodeForDropdown();
    this.GetAllCUSTIdsForDropdown();
  }

  GetChitSchemeCodeForDropdown() {
    debugger;
      this.data = this.service.getChitSchemeCodeForDropdown();
      this.data.subscribe(
        (response:any) => {
          this.chitschemecodelist = response;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }

  GetChitDetails(schid){
    debugger;
    this.data = this.service.getChitDetails(schid);
    this.data.subscribe(
      (response:any) => {
        this.chitdetails = response;
        this.c.ChitABB=this.chitdetails[0].ChitABB;
        this.c.ChitName=this.chitdetails[0].ChitName;
        if(this.chitdetails[0].StartDate!=null)
        this.c.StartDate=((this.chitdetails[0].StartDate).split('T'))[0];
        this.c.ChitAmount=this.chitdetails[0].ChitAmount;
        this.c.MonthlyAmount=this.chitdetails[0].MonthlyAmount;
        this.c.NoOfMonths=this.chitdetails[0].NoOfMonths;
        console.log(response);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
  }

  //Details based on Token no.
  GetDetailsBasedOnTokenNo(TokenNo,SCHID)
  {
    debugger;
      this.data = this.service.getDetailsBasedOnTokenNo(TokenNo,SCHID);
      this.data.subscribe(
        (response:any) => {
          this.detailsBasedOntokenNo = response;
          console.log(this.detailsBasedOntokenNo);
          this.c.CUSTID=this.detailsBasedOntokenNo[0].CUSTID;
          this.c.ShareNumber=this.detailsBasedOntokenNo[0].ShareNumber;
          this.c.Name=this.detailsBasedOntokenNo[0].Name;
          this.c.AccNo=this.detailsBasedOntokenNo[0].AccNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }



  GetAllCUSTIdsForDropdown() {
    debugger;
      this.data = this.service.getAllCUSTIdsForDropdown();
      this.data.subscribe(
        (response:any) => {
          this.custIdslist = response;
          console.log('rrrrr');
          console.log(this.custIdslist);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }



  //Details based on CustId.
  GetDetailsBasedOnCustId(CustId,SCHID)
  {
    debugger;
      this.data = this.service.getDetailsBasedOnCustId(CustId,SCHID);
      this.data.subscribe(
        (response:any) => {
          this.detailsBasedOnCustId = response;
          console.log(this.detailsBasedOntokenNo);
          this.c.CUSTID=this.detailsBasedOnCustId[0].CUSTID;
          this.c.ShareNumber=this.detailsBasedOnCustId[0].ShareNumber;
          this.c.Name=this.detailsBasedOnCustId[0].Name;
          this.c.AccNo=this.detailsBasedOnCustId[0].AccNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }




}



// WEBPACK FOOTER //
// ./src/app/chitfund/chitmember-transfer/chitmember-transfer.component.ts